import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import style from "./account.module.scss";
import useAppModernisation from "../../hooks/useAppModernisation";

const AccountMenu = ({ name, route, isExternal = false, onClickFuc, hideIcon = false }) => {
  const navigate = useNavigate();
  const menuClass = classNames(style.accountMenu);
  const { isMobileView } = useAppModernisation();
  const iconClass = isMobileView ? "tg-icons-LeftArrow" : "tg-icons-Open";

  const handleButtonClick = () => {
    if (route) {
      if (isExternal) {
        window.open(route, "_blank");
        return;
      }
      navigate(route);
    }
    if (onClickFuc) {
      onClickFuc();
    }
  };
  return (
    <div className={menuClass} onClick={handleButtonClick}>
      <span className={style.menuTitle}>{name}</span>
      <button className={style.button}>
        {!hideIcon &&
          <i className={iconClass} />
        }
      </button>
    </div>
  );
};

AccountMenu.propTypes = {
  name: PropTypes.string.isRequired,
  route: PropTypes.string,
  isExternal: PropTypes.bool,
  onClickFuc: PropTypes.func,
};

export default AccountMenu;
